import React, { memo, useEffect, useState } from 'react';
import { CircleMarker, Polyline } from 'react-leaflet';

const shouldMemo = (prevProps, nextProps) => (
  prevProps.planned_routes === nextProps.planned_routes
  && prevProps.map === nextProps.map
);

const getCoordinates = ((routes) => routes.map(({ place }) => place));

const TrackRoutes = memo(({
  planned_routes,
  getTrackCircleChildren,
  map,
  pathOptions,
  shouldShowPoints = false,
}) => {
  const [plannedRoutes, setPlannedRoutes] = useState([]);

  useEffect(() => {
    if (plannedRoutes?.length > 0) {
      map?.fitBounds?.(getCoordinates(plannedRoutes));
    }
    /* eslint-disable-next-line */
  }, [plannedRoutes, map]);

  useEffect(() => {
    if (planned_routes?.length) {
      setPlannedRoutes(planned_routes.map((item) => ({
        ...item,
        place: [item?.place?.x, item?.place?.y],
      })));
    } else setPlannedRoutes([]);
  }, [planned_routes]);

  if (!plannedRoutes?.length) return null;

  return (
    <>
      <Polyline pathOptions={pathOptions} positions={getCoordinates(plannedRoutes)} />
      {shouldShowPoints
        && plannedRoutes.map(({ place }, index) => (
          <CircleMarker center={[place?.[0], place?.[1]]} radius={3}>
            {getTrackCircleChildren && getTrackCircleChildren(index)}
          </CircleMarker>
        ))}
    </>
  );
}, shouldMemo);

export default TrackRoutes;
